// Module
var code = `<div class="js-panel-report-main">
    <div class="js-panel-report-body">
        <div class="js-group-panel">
            <div class="js-group-panel-left-container">
                <terceraLabel text="{{.reportTypeString}}"/>
            </div>
            <div class="js-group-panel-right-container">
                <terceraComboBox listWidth="{{.reportsComboBoxListItemsWidth}}" 
                items="{{.reportsComboBoxList}}" 
                selectedItem="{{.selectedReportComboItem}}"/>
            </div>
        </div>
        <terceraPanel name="paramsPanel" />
    </div>

    <div class="js-panel-report-footer">
        <!-- {{#if .loading}} -->
        <terceraButton terceraButtonStyle="js-button-blue" 
            text="{{.cancelBtnText}}" 
            on-btnClick="cancelPromise"
            visible="{{.loading}}"
            />
        <!-- {{else}} -->
        <terceraComboBox name="reportBtn" selectedItem={{.exportToTitleItem}}
            elementStyle="js-combobox-reports" items={{.exportToCBItems}} on-ComboItemClicked="onExportToClick" 
            visible="{{!.loading}}"
            />
        <!-- {{/if}} -->
    
        <terceraLabel text="{{.noDataErrorText}}" visible="{{.noDataErrorVisibility}}"/>
    </div>
</div>`;
// Exports
export default code;